import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" id=\"icon-close\">\n    <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.061 9.501l7.614-7.614a1.102 1.102 0 0 0 0-1.562 1.101 1.101 0 0 0-1.562 0L9.5 7.939 1.885.325A1.106 1.106 0 0 0 .323 1.887l7.614 7.614-7.614 7.614a1.106 1.106 0 0 0 1.562 1.562L9.5 11.063l7.614 7.614a1.11 1.11 0 0 0 1.562 0 1.102 1.102 0 0 0 0-1.562l-7.614-7.614z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/close.svg
// module id = 399
// module chunks = 2